import { render, staticRenderFns } from "./SearchResultItemProfile.vue?vue&type=template&id=098f3682&scoped=true&"
import script from "./SearchResultItemProfile.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemProfile.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemProfile.vue?vue&type=style&index=0&id=098f3682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f3682",
  null
  
)

export default component.exports